import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { useState } from 'react';

export default function useIsKeyboardVisible() {
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  if (Capacitor.isPluginAvailable('Keyboard')) {
    Keyboard.addListener('keyboardDidShow', () => {
      setIsKeyboardVisible(true);
    });

    Keyboard.addListener('keyboardDidHide', () => {
      setIsKeyboardVisible(false);
    });
  }
  return {
    isKeyboardVisible,
  };
}
